import React, { useState, useEffect, useRef } from 'react';
import baseURL from "../component/baseURL";
import { useNavigate } from 'react-router-dom';
import stringsoflanguages from '../component/stringsoflanguages';


export default function ConnectionRequest({ isMobile, onOpenConnectionRequestSend }) {
    const [userID, setUserID] = useState(null);
    const [connectionRequests, setConnectionRequests] = useState([]);
    const [isPremium, setIsPremium] = useState(false);
    const [loading, setLoading] = useState(true);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [requestSentCount, setRequestSentCount] = useState(0);
    const gearMenuRef = useRef(null);
    const navigate = useNavigate();

    const handleSendRequestClick = () => {
        if (isMobile) {
            navigate('/home/connection-request-send');
        } else {
            onOpenConnectionRequestSend?.();
        }
    };

    const handleMemberCardClick = (member) => {
        const scrollPosition = window.scrollY ?? document.documentElement.scrollTop ?? 0;
        sessionStorage.setItem('connectionRequestsScrollPosition', String(scrollPosition));
        navigate('/member-profile', {
            state: {
                memberID: member.user_id,
                member,
                scrollPosition,
                from: '/home/connection-request'
            }
        });
    };
    useEffect(() => {
        const handleGearClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleGearClickOutside);
        return () => document.removeEventListener('mousedown', handleGearClickOutside);
    }, []);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);

        fetchConnectionRequestAPI(userid);
        if (userid) fetchCountMembers(userid);
    }, []);

    function fetchCountMembers(userid) {
        const formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/member/count_members', {
            method: 'POST',
            body: formdata
        }).then((res) => res.json())
            .then((data) => {
                if (data.server?.result_code === 200 && data.response?.member_counts) {
                    const n = data.response.member_counts.request_sent;
                    setRequestSentCount(n != null ? Number(n) : 0);
                }
            })
            .catch(() => { });
    }


    function fetchConnectionRequestAPI(userid) {
        // console.log(this.state.userID)
        // const { navigate } = this.props.navigation;
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("member_type", 'request_received')
        console.log(formdata);
        fetch(baseURL.URL + '/member/fetch_members', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                const result = responseJson.response.member_list
                console.log(result[1]);
                if (responseJson.server.result_code === 200) {
                    const res = responseJson.response;
                    setConnectionRequests(result || []);
                    const premium = res.isPremium === true || res.is_premium === true || res.is_premium === 1;
                    setIsPremium(Boolean(premium));
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }


    function acceptRequestAPI(connectionID, connectionStatus, memberID) {

        // const { navigate } = this.props.navigation;
        let formdata = new FormData();

        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        //formdata.append("member_type", 'request_received')
        formdata.append("connections_id", connectionID)
        formdata.append("user_id", userID)
        formdata.append("connection_status", connectionStatus)
        formdata.append("sender_id", memberID)
        formdata.append("receiver_id", userID)
        fetch(baseURL.URL + '/member/respond_connection_req', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                if (userID) fetchCountMembers(userID);
                const result = responseJson.response
                console.log(result)
                if (responseJson.server.result_code === 200) {
                    // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    // this.fetchDetailsAPI()
                    setTimeout(() => { fetchConnectionRequestAPI(userID) }, 100)
                }
                else {
                    // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    if (loading) {
        return (
            <div className="content-right page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="content-right">
                {/* Search and Filter Section - same as MyConnection */}
                <div className="search-filter-section">
                    <div className="search-bar">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className="search-icon"
                        >
                            <path
                                d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                stroke="#E1730B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17.5 17.5L13.875 13.875"
                                stroke="#E1730B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <input
                            type="text"
                            placeholder="Search by name / company"
                            className="search-input"
                        />
                    </div>
                    <button className="filter-btn">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                                fill="white"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                </div>

                <h3 className='section-title-header'>{stringsoflanguages.requestReceived}</h3>
                {/* Member Cards Grid - same layout as MyConnection */}
                <div className="member-cards-grid">
                    {connectionRequests.length === 0 ? (
                        <p className="no-data-message">{stringsoflanguages.noRequestFound}</p>
                    ) : (
                        connectionRequests.map((connection) => (
                            <div className="member-card cursor-pointer" key={connection.id} onClick={() => handleMemberCardClick(connection)}>
                                <div className="member-info">
                                    <p className="member-since">Member since {connection.added_date}</p>
                                    <h3 className="member-name">{connection.member_fname} {connection.member_lname}</h3>
                                    <p className="member-role">{connection.title}</p>
                                    <p className="member-location">{connection.city_name}, {connection.country_name}</p>
                                    <div className="member-card-actions-inline">
                                        <button className="accept-btn" onClick={() => acceptRequestAPI(connection.connection_id, 'RequestAccepted', connection.user_id)}>Accept</button>
                                        <button className="decline-btn" onClick={() => acceptRequestAPI(connection.connection_id, 'RequestDenied', connection.user_id)}>Decline</button>
                                    </div>
                                </div>
                                <div className="member-image">
                                    <img src={connection.member_image_thumb} alt={connection.member_fname} />
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {/* Desktop only: gear icon with dropdown (Send Request) */}
                {!isMobile && (
                    <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                        <button
                            type="button"
                            className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                            onClick={() => {
                                setGearMenuOpen((prev) => !prev);
                                setGearSpinning(true);
                                setTimeout(() => setGearSpinning(false), 500);
                            }}
                            aria-label="Options"
                            aria-expanded={gearMenuOpen}
                        >
                            <i className="fa-solid fa-gear"></i>
                        </button>
                        {gearMenuOpen && (
                            <ul className="gear-dropdown" aria-label="Options list">
                                <li>
                                    <button type="button" className="gear-dropdown-item" onClick={() => { setGearMenuOpen(false); handleSendRequestClick(); }}>
                                        <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                        <span>{stringsoflanguages.sendRequest}</span>
                                        {requestSentCount > 0 && <span className="nav-item-icon-count gear-dropdown-count">{requestSentCount}</span>}
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                )}
            </div>

            {/* Mobile: bottom nav with Send Request icon */}
            {isMobile && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock connection-request-footer-nav" aria-label="Connection request actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    <div className="mobile-nav-item mobile-nav-item-with-count" onClick={handleSendRequestClick} aria-label="Send Request">
                        <i className="fa-solid fa-arrow-up-from-bracket"></i>
                        {requestSentCount > 0 && <span className="mobile-nav-item-count">{requestSentCount}</span>}
                    </div>
                </nav>
            )}
            <svg style={{ display: 'none' }} aria-hidden="true">
                <filter id="glass-distortion-connection-request" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5" result="turbulence" />
                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100" lightingColor="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>
                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </svg>
        </React.Fragment>
    );
}